import {
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { FormControl, UntypedFormArray, UntypedFormBuilder, UntypedFormControl, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { AddDocumentComponent } from '@app/modules/vault/components/add-document/add-document.component';
import { EditTemplateBasicFormComponent } from '@app/shared/component/discovery-setup-detail/widgets/contact/sub-component/stepper-manage-contact-list/create-associated-form/edit-template-basic-form/edit-template-basic-form.component';
import { loaderTypes } from '@app/shared/component/loader/loader';
import { DocumentService } from '@app/shared/services';
import { ShareService } from '@app/shared/services/vault/share.service';
import { Observable, Subscription } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { SharedVaultService } from '@app/shared/services/vault/shared-vault.service';
import { SharedConfirmationDialogComponent } from '@app/shared/component/shared-confirmation-dialog/shared-confirmation-dialog.component';
import { RootStoreState, vaultStoreActions } from '@app/root-store';
import { Store } from '@ngrx/store';
import { DiscoveryService } from '@app/shared/services/discovery/discovery.service';
import { RenameInstitutionDialogComponent } from '../rename-institution-dialog/rename-institution-dialog.component';
import { EditAddLinkedTemplatePopupComponent } from '@app/modules/vault/components/add-document/linked-templates/edit-add-linked-template-popup/edit-add-linked-template-popup.component';
import { ConnectToMxComponent } from '@app/modules/vault/mx-component/dialog/connect-to-mx/connect-to-mx.component';
import { MxTaskbarService } from '@app/shared/services/mx-taskbar/mx-taskbar.service';
import { MatSelect } from '@angular/material/select';
import { ToastrService } from 'ngx-toastr';
import { AutoUnsubscribe } from '@app/shared/decorators/auto-unsubscribe.decorator';
@AutoUnsubscribe()
@Component({
  selector: 'discovery-template-table-form',
  templateUrl: './discovery-template-table-form.component.html',
  styleUrl: './discovery-template-table-form.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DiscoveryTemplateTableFormComponent implements OnInit, OnDestroy, AfterViewInit, OnChanges {
  @ViewChild(EditTemplateBasicFormComponent) editTemplateBasicForm!: EditTemplateBasicFormComponent;
  @ViewChild('nameInput') nameInput!: ElementRef<HTMLInputElement>;
  @ViewChild('userSelect') userSelect: MatSelect;
  @Input() rowData: any;
  @Input() index: number;
  @Input() vaults = [];
  @Input() forms = [];
  @Input() userObject;
  @Input() path;
  @Input() allUserConnections = [];
  @Input() logInUser = {
    user_id: '',
    name: '',
  };
  @Input() isOwnerRegisterDataType = false;
  @Input() registerType = '';
  @Output() remove = new EventEmitter<void>();
  @Output() update = new EventEmitter<any>();
  @Output() handleAddNewFinancialAccount = new EventEmitter<any>();
  @Output() getFormsTypeUser = new EventEmitter<any>();
  @Input() isDiscoveryType6 = false;
  @Input() isCredentials = false;
  @Input() isInstitutions = false;
  @Input() selectedAccounts: any = {};

  myControl = new FormControl('');
  subscription = new Subscription();
  formInfo: any = {};
  isEditInputField = false;
  isEditSelectedVault = false;
  isFocused = false;
  filteredVaults$: Observable<any[]>;
  isLoadingRow = false;
  documentForm;
  formData = [];
  current_template;
  securityStateObject;
  vault_id;
  formTypes = [{ value: 'Individual' }, { value: 'Group' }];
  isEditTypeSelect = false;
  isEditMemberSelect = false;
  selectedFormId;
  nonProfessionalUsers = [];
  connectionUserFormControl = new UntypedFormControl();
  selectedUsers = [];
  searchText: string | null = null;
  selectedVault: any = null;
  vaultMembers = [];
  connectCredentials = true;
  isAccountCreationInProgress = false;
  selectedType;
  isDialogOpen = false; // Add flag to prevent multiple dialogs

  constructor(
    private cd: ChangeDetectorRef,
    private documentService: DocumentService,
    private formBuilder: UntypedFormBuilder,
    private shareService: ShareService,
    private dialog: MatDialog,
    private vaultService: SharedVaultService,
    private store$: Store<RootStoreState.State>,
    private discoveryService: DiscoveryService,
    private mxTaskbarService: MxTaskbarService,
    private toastr: ToastrService
  ) {
    this.filteredVaults$ = this.myControl.valueChanges.pipe(
      startWith(''),
      map((value) => this.filterVaults(value || ''))
    );
  }

  ngAfterViewInit() {
    setTimeout(() => {
      if (!this.nameInput.nativeElement.disabled) {
        this.nameInput.nativeElement.focus();
        this.nameInput.nativeElement.select();
      }
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    // if (changes['formInfo']) {
    // }
  }

  ngOnInit(): void {
    this.selectedFormId = this.path.formId;
    this.formInfo = this.rowData;
    this.processInitialData();
    // if(this.path.template && this.path.template2){
    //   this.formTypes = this.forms.filter((form) => form.type === this.path.template || form.type === this.path.template2).map((form) => ({ value: form.type }));
    // } else {
    //   this.formTypes = this.forms.filter((form) => form.type_template === this.path.path_name).map((form) => ({ value: form.type }));
    // }
  }

  processInitialData() {
    // if (!this.formInfo.form_name) {
    //   this.formInfo.form_name = 'Untitled';
    // }
    if (this.formInfo.vault_name) {
      this.myControl.setValue(this.formInfo.vault_name);
      this.myControl.disable();
    }
    // if (this.path.data_type === 'Entities' || this.isOwnerRegisterDataType) {
    //   this.selectedUsers.push(this.userObject.id);
    // }
    if (this.vaults?.length && this.formInfo.vault_id) {
      this.isEditSelectedVault = true;
      const selectedVault = this.vaults.find((vault) => vault.id === this.formInfo.vault_id);
      this.selectedVault = selectedVault?.id;
      if (this.path.data_type === 'Entities') {
        this.vaultMembers = [...selectedVault.vaultMembers];
        this.selectedUsers = [...selectedVault.vaultMembers.map((member) => member.user_id)];
      }
    }
    if (this.formInfo.sharedUsers) {
      this.vaultMembers = [...this.formInfo.sharedUsers];
      this.selectedUsers = [...this.formInfo.sharedUsers.map((member) => member.user_id)];
    }
    if (this.formInfo.fid === this.path.form2Id) {
      this.formInfo.type = 'Group';
    } else if (this.path.path_name !== 'Financial Accounts') {
      this.formInfo.type = 'Individual';
    }
    this.cd.detectChanges();
  }

  filterVaults(searchText: string): any[] {
    const lowerCaseSearch = searchText.toLowerCase();
    return this.vaults.filter((vault) => vault.name.toLowerCase().includes(lowerCaseSearch));
  }

  get filteredVaults() {
    return this.vaults.filter((vault) => vault.name.toLowerCase().includes(this.searchText.toLowerCase()));
  }

  handleVaultNameForMultipleNames(vaultName) {
    const hasDuplicateNames = vaultName.trim().split('&');
    if (!hasDuplicateNames[1]) {
      return vaultName;
    }
    const secondName = hasDuplicateNames[1].trim().split('vault');
    return `${hasDuplicateNames[0] + ' ' + '&' + ' ' + secondName[0].trim()}'s Vault`;
  }

  selectVault(vault) {
    if (this.formInfo.id) {
      this.moveFormToVault(vault.id, vault.user_id);
      return;
    }
    if (!this.formInfo.form_name.trim()) {
      this.toastr.error(`Please enter a name for the ${this.formInfo.template}`);
      return;
    }
    this.isEditSelectedVault = true;
    this.selectedVault = vault.id;
    this.formInfo.selectedVault = vault.id;
    this.searchText = '';
    this.isLoadingRow = true;
    if (this.path.path_name === 'Financial Accounts') {
      this.selectedFormId = this.forms.find((form) => form.type === this.formInfo.type)?.id;
    } else if (this.formInfo.type === 'Group') {
      this.selectedFormId = this.path.form2Id || this.path.formId;
    } else {
      this.selectedFormId = this.path.formId;
    }
    this.createTemplate(this.selectedVault);
    this.cd.detectChanges();
  }

  onClearInput() {
    this.myControl.setValue('');
    this.cd.detectChanges();
  }

  handleInput(event) {
    if (!this.isEditInputField) {
      // On first input, clear the highlighted value and set new value
      this.formInfo.form_name = event.target.value.slice(-1); // Keep only the last character typed
      this.isEditInputField = true;
    }
    this.cd.detectChanges();
  }

  typeSelectInputKeyDown(event) {
    if (event.key || event.type) {
      this.isEditTypeSelect = true;
    }
    this.cd.detectChanges();
  }

  memberSelectInputKeyDown(event) {
    if (event.key || event.type) {
      this.isEditMemberSelect = true;
    }
    this.cd.detectChanges();
  }

  selectInputKeyDown(event) {
    if (event.key || event.type) {
      this.isEditSelectedVault = true;
    }
    this.cd.detectChanges();
  }

  removeRow() {
    this.remove.emit();
    this.cd.detectChanges();
  }

  updateRow() {
    this.update.emit(this.formInfo);
    this.isEditSelectedVault = true;
    this.cd.detectChanges();
  }

  displayMember() {
    const connections = [...this.allUserConnections]; // Copy existing connections

    if (this.userObject?.id) {
      connections.push({ ...this.userObject, user_id: this.userObject.id }); // Add the logged-in user
    }

    return connections
      .filter((s) => this.selectedUsers.includes(s.user_id)) // Filter selected users
      .map((s) => s.name) // Extract names
      .join(', '); // Join names with a comma
  }

  displayVault() {
    return this.vaults.find((vault) => vault.id === this.selectedVault)?.name;
  }

  selectedUsersChange() {
    // Only proceed if there's an actual selection change, not during search
    if (!this.userSelect?.selected) {
      return;
    }

    if (!this.formInfo?.fid) {
      this.userSelect.close();
      this.cd.detectChanges();
      this.createEntity();
    }
  }

  memberChange(event) {
    if (!event.isUserInput) {
      return;
    }
    if (!this.formInfo?.fid) {
      return;
    }
    if (this.path.data_type === 'Entities') {
      if (event.isUserInput) {
        if (!event.source.selected) {
          // Store the value before deletion attempt
          const valueToDelete = event.source.value;
          this.deleteMember(valueToDelete);
        } else {
          this.addMember(event.source.value);
        }
      }
    } else {
      if (event.isUserInput) {
        if (!event.source.selected) {
          const user = this.vaultMembers.find((member) => member.user_id === event.source.value);
          this.vaultMembers.splice(this.vaultMembers.indexOf(user), 1);
          this.deleteRegisterMember(
            event.source.value,
            this.isCredentials ? this.formInfo.id : this.formInfo.owner_vault_user_form_id,
            user.vault_user_share_id,
            () => {
              // If deletion was cancelled, reselect the value
              this.selectedUsers.push(event.source.value);
              this.cd.detectChanges();
            }
          );
        } else {
          this.createRegisterOwner(event.source.value, this.isCredentials ? this.formInfo.id : this.formInfo.owner_vault_user_form_id);
        }
      }
    }
  }

  createEntity() {
    if (this.formInfo.fid) {
      return;
    }
    if (!this.formInfo.form_name.trim()) {
      this.toastr.error(`Please enter a name for the ${this.formInfo.template}`);
      return;
    }
    if (!this.selectedUsers.length) {
      this.toastr.error(`Please select at least one user`);
      return;
    }
    if (this.isOwnerRegisterDataType || this.isCredentials) {
      this.searchText = '';
      this.isLoadingRow = true;
      this.createTemplate(null);
      return;
    }
    if (this.path.data_type !== 'Entities') {
      return;
    }
    this.searchText = '';
    this.isLoadingRow = true;
    const vaultMembers = [];
    vaultMembers.push({
      user_email: this.userObject?.email,
      user_id: this.userObject?.id,
      user_profile_image_url: this.userObject?.profile_image_url,
      name: this.userObject?.name,
      user_first_name: this.userObject?.first_name,
      type: 'owner',
      is_limited: false,
      isSelected: true,
    });
    for (let index = 0; index < this.selectedUsers.length; index++) {
      const element = this.selectedUsers[index];
      if (element !== this.userObject.id) {
        vaultMembers.push({
          user_id: element,
          type: 'member',
          is_limited: false,
        });
      }
    }

    const payload = {
      name: this.formInfo.form_name.trim() ?? 'Untitled Vault',
      type: 'entity',
      user_id: this.userObject?.id,
      member: vaultMembers.map(({ user_id, type, is_limited }) => ({ user_id, type, ...(is_limited !== undefined && { is_limited }) })),
    };
    this.subscription.add(
      this.vaultService.createVault(payload, true).subscribe(
        async (data) => {
          if (data) {
            this.store$.dispatch(new vaultStoreActions.GetVaultRequestAction(this.userObject?.id, false));
            await this.createTemplate(data.id);
            this.getVaultMembers(data.id);
          }
        },
        (error: any) => {
          console.error('🚀 ~ DiscoveryTemplateTableFormComponent ~ createEntity ~ error:', error);
          this.isLoadingRow = false;
        }
      )
    );
  }

  editFeedData(item) {
    try {
      if (this.isDialogOpen) {
        return;
      }
      if (!item || !this.userObject?.id) {
        return;
      }
      this.closeExistingDialogs();
      setTimeout(() => {
        this.isDialogOpen = true;
        item.user_id = this.userObject.id;

        const dialogConfig = {
          width: '400px',
          maxWidth: '80vw',
          autoFocus: false,
          data: {
            formName: item.formName,
            mx_connected_clients: [],
            title: 'Financial Institution',
            enable_linking: true,
            allowedOne: false,
            currentFormId: item.id,
            type_template: item.type_template,
            currentValutUserId: this.userObject.id,
            vault_user_form_id: item.id,
          },
        };

        const dialogRef: MatDialogRef<ConnectToMxComponent> = this.mxTaskbarService.openMxDialog(ConnectToMxComponent, dialogConfig);

        if (!dialogRef) {
          console.error('Dialog reference is null - dialog failed to open');
          this.toastr.error('Failed to open connection dialog. Please try again.');
          this.isDialogOpen = false;
          return;
        }

        this.subscription.add(
          dialogRef.afterClosed().subscribe((val) => {
            this.isDialogOpen = false; // Reset flag when dialog closes
            if (val?.success) {
              this.getFormsTypeUser.emit();
            }
          })
        );
      }, 100);
    } catch (error) {
      this.isDialogOpen = false;
    }
  }

  private closeExistingDialogs(): void {
    try {
      // Close all existing dialogs
      this.dialog.closeAll();
    } catch (error) {
      console.error('Error closing existing dialogs:', error);
    }
  }

  private isFormReadyForConnection(): boolean {
    return !!(this.formInfo?.fid && this.userObject?.id);
  }

  onConnectButtonClick(event: Event, formInfo: any): void {
    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
    this.editFeedData(formInfo);
  }

  viewModal(data: { file; event?: any }) {
    const path = data.event.path || (data.event.composedPath && data.event.composedPath());
    if (
      path[1].id !== 'toggleMoreWrapper' &&
      path[1].id !== 'checkbox-input-select' &&
      path[1].id !== 'toggleMore' &&
      path[1].classList[0] !== 'see-more__popup' &&
      path[1].classList[0] !== 'popup__wrapper' &&
      path[2].id !== 'kinnect-avatar' &&
      path[1].classList[0] !== 'share-from-stats' &&
      path[0].classList[0] !== 'share-from-stats' &&
      path[0].classList[0] !== 'not-shared-button' &&
      path[0].classList[0] !== 'checkbox-input' &&
      path[1].classList[0] !== 'mat-checkbox-layout' &&
      path[1].classList[1] !== 'Comment-notes-card'
    ) {
      const dialogRef = this.dialog.open(AddDocumentComponent, {
        disableClose: true,
        data: { file: data.file, mode: 'edit', isintelligent: false, isfileListLoad: true },
        panelClass: 'full-window-dialog-add-document',
        autoFocus: false,
      });
      this.subscription.add(
        dialogRef.afterClosed().subscribe(() => {
          if (this.path.path_name === 'Financial Accounts') {
            this.getDiscoveryFinancialAccountsForms(this.formInfo.id);
          } else if (this.isOwnerRegisterDataType) {
            this.getNonVaultForms(this.formInfo.id);
          } else {
            this.getFormData(this.formInfo.id);
          }
        })
      );
    }
  }

  createformIdForFirstUploadDocument(argument) {
    return new Promise((resolve) => {
      const data = {
        user_id: this.userObject.id,
        vault_form_id: argument.vaultFormId,
        vaultId: argument.vaultId,
        url: 'my-vault/0',
        template_sub_type: this.path.path_name,
        origin: this.registerType === 'contact' || this.registerType === 'password' ? this.registerType : '',
        discovery_financial_account_id: this.selectedAccounts?.id,
      };
      this.subscription.add(
        this.documentService.getforIdForFirstUploadDocument(data, loaderTypes.none).subscribe(
          (res) => {
            this.vault_id = res['vault_user_form_id']?.vault_id;
            this.securityStateObject = res['vault_user_form_id']?.public_key;
            if (res.vault_user_form_id.vault_user_form_id) {
              resolve({ vault_form_id: argument.vaultFormId, hub_vault_user_form_id: res.vault_user_form_id.vault_user_form_id, argument });
            }
          },
          (error) => {
            console.error('🚀 ~ DiscoveryTemplateTableFormComponent ~ returnnewPromise ~ error:', error);
          }
        )
      );
    });
  }

  initFormData(vaultFormId) {
    this.current_template = this.forms.find((x) => x.id === vaultFormId);
    this.documentForm = this.formBuilder.group({
      documentType: ['', Validators.required],
      documentName: [this.formInfo.form_name, Validators.required],
      status_progress: ['need to add', Validators.required],
      formSelection: ['', Validators.required],
      selectSaveFolder: ['', Validators.required],
      selectOfficeSaveFolder: ['', Validators.required],
      dynamicFieldsForm: new UntypedFormArray([]),
      beneFicaryForm: new UntypedFormArray([]),
      attributeFormsList: new UntypedFormArray([]),
      showNotes: [''],
      physicalLocation: [''],
      notes: [''],
      expiration_date: [''],
      expiration_notification: [''],
      review_date: [''],
      review_notification: [''],
      renewal_notification: [''],
      renewal_date: [''],
      recurring_expiration: [''],
      value_currency: ['USD'],
      value_current_currency: [''],
      value_is_appraisal: [''],
      value_appraisal_date: [''],
    });
    this.formData = this.current_template.template;
    this.cd.detectChanges();
  }

  updateFormTemplateData(vault_user_form_id) {
    return new Promise(async (resolve) => {
      const payload = {
        id: vault_user_form_id,
        status_progress: 'need to add',
        user_id: this.userObject.id,
        form_data: {
          beneFicaryForm: [],
          dynamicFieldsForm: this.documentForm.controls.dynamicFieldsForm.value[0],
          showNotes: undefined,
        },
        user_pk: this.securityStateObject.public_key,
      };
      this.subscription.add(
        this.documentService.updateFormTampletData(payload, null, undefined, undefined, false, undefined).subscribe(
          (res) => {
            resolve(res);
          },
          (error) => {
            console.error('🚀 ~ DiscoveryTemplateTableFormComponent ~ returnnewPromise ~ error:', error);
          }
        )
      );
    });
  }

  formName(hub_vault_user_form_id) {
    return new Promise((resolve) => {
      this.documentForm.controls.dynamicFieldsForm.value[0].foreignDisregardedEntityFullLegalNameofEntity = this.formInfo?.form_name;
      this.subscription.add(
        this.documentService
          .saveNameWithAction({
            form_name: this.formInfo?.form_name,
            id: hub_vault_user_form_id,
            naming_convention: 'General Information',
            dynamicFieldsForm: this.documentForm.controls.dynamicFieldsForm.value[0],
            user_id: this.userObject.id,
            current_template: this.current_template,
            filterArrayItems: this.editTemplateBasicForm.filterArrayItems,
            vault_id: this.vault_id,
            vault_list: this.vaults,
          })
          .subscribe(
            (res) => {
              resolve(res);
            },
            (error) => {
              console.error('🚀 ~ DiscoveryTemplateTableFormComponent ~ returnnewPromise ~ error:', error);
            }
          )
      );
    });
  }

  createFinancialAccount() {
    if (!this.isDiscoveryType6) {
      return;
    }
    if (this.isAccountCreationInProgress) {
      return;
    }
    if (!this.formInfo.form_name.trim()) {
      this.toastr.error('Please enter a name for the financial account');
      return;
    }
    this.isAccountCreationInProgress = true;
    this.searchText = '';
    this.isLoadingRow = true;
    this.subscription.add(
      this.discoveryService.createDiscoveryFinancialAccount({ name: this.formInfo.form_name.trim() }).subscribe((res) => {
        this.formInfo = {
          ...res,
          form_name: this.formInfo.form_name.trim(),
          fid: res.id,
        };
        this.handleAddNewFinancialAccount.emit({ data: this.formInfo, index: this.index });
        this.isLoadingRow = false;
        setTimeout(() => {
          this.isAccountCreationInProgress = false;
          this.cd.detectChanges();
        }, 500);
        this.cd.detectChanges();
      })
    );
  }

  getDiscoveryFinancialAccountsForms(vault_form_id) {
    this.subscription.add(
      this.discoveryService.getAllUserFormByDiscoveryFinancialAccountId().subscribe((res) => {
        const currentForm = res.find((form) => form.id === vault_form_id);
        if (currentForm) {
          this.formInfo = { ...currentForm };
        }
        this.isLoadingRow = false;
        this.updateRow();
        this.cd.detectChanges();
      })
    );
  }

  getFormData(vault_form_id) {
    const ids = [this.formInfo?.formId || this.formInfo?.fid];
    if (this.formInfo?.form2Id) {
      ids.push(this.formInfo?.form2Id);
    }
    this.subscription.add(
      this.shareService.getFormsTypeUser({ formids: ids }).subscribe(
        (res) => {
          const currentForm = res.find((x) => x.id === vault_form_id);
          if (currentForm) {
            Object.keys(currentForm).forEach((key) => {
              this.formInfo[key] = currentForm[key];
            });
          }
          if (this.formInfo.fid === this.path.form2Id) {
            this.formInfo.type = 'Group';
          } else {
            this.formInfo.type = 'Individual';
          }
          this.isLoadingRow = false;
          this.cd.detectChanges();
          this.updateRow();
        },
        (error) => {
          console.error(error);
        }
      )
    );
  }

  getNonVaultForms(vault_form_id) {
    this.subscription.add(
      this.vaultService.getNonVaultForms(this.registerType, null).subscribe(
        (res) => {
          let currentForm;
          if (this.registerType === 'contact') {
            currentForm = res.find((x) => x.template_sub_type === this.path.path_name);
          } else {
            currentForm = res.find((form) => form.id === vault_form_id);
          }
          if (currentForm) {
            this.formInfo = { ...currentForm };
          }
          this.isLoadingRow = false;
          this.updateRow();
          this.cd.detectChanges();
        },
        () => {
          this.cd.detectChanges();
        }
      )
    );
  }

  async createTemplate(vault_id) {
    const formData: any = await this.createformIdForFirstUploadDocument({
      vaultFormId: this.selectedFormId,
      title: this.formInfo?.template,
      vaultType: this.formInfo?.selectedVault?.type,
      hub_vault_user_form_id: null,
      origin: 'onboarding',
      vaultId: vault_id,
    });
    this.formData = [];
    this.cd.detectChanges();
    try {
      this.initFormData(formData.vault_form_id);
      await this.updateFormTemplateData(formData.hub_vault_user_form_id);
      await this.formName(formData.hub_vault_user_form_id);
      if (this.isOwnerRegisterDataType) {
        for (let index = 0; index < this.selectedUsers.length; index++) {
          const element = this.selectedUsers[index];
          if (element !== this.userObject.id) {
            await this.createRegisterOwner(element, formData.hub_vault_user_form_id);
          }
        }
      }
      if (this.path.path_name === 'Financial Accounts') {
        this.getDiscoveryFinancialAccountsForms(formData.hub_vault_user_form_id);
      } else if (this.isOwnerRegisterDataType) {
        this.getNonVaultForms(formData.hub_vault_user_form_id);
      } else {
        this.getFormData(formData.hub_vault_user_form_id);
      }
      if (!this.selectedUsers.includes(this.userObject.id)) {
        this.selectedUsers.push(this.userObject.id);
      }
      this.cd.detectChanges();
    } catch (error) {
      console.error('🚀 ~ DiscoveryTemplateTableFormComponent ~ createTemplate ~ error:', error);
    }
  }

  addMember(user_id) {
    const model = {
      vault_id: this.formInfo.vault_id,
      user_id: user_id,
    };
    this.subscription.add(
      this.vaultService.createVaultMember(model).subscribe((data) => {
        if (data) {
          this.vaultMembers = [...this.vaultMembers, data];
          this.store$.dispatch(new vaultStoreActions.GetVaultRequestAction(this.userObject?.id, false));
          this.cd.markForCheck();
        }
      })
    );
  }

  deleteMember(value) {
    const sharedDialogRef = this.dialog.open(SharedConfirmationDialogComponent, {
      width: '400px',
      data: {
        title: 'Delete',
        materialIcon: 'delete',
        text: `Are you sure you want to delete this member?`,
        proceedTitle: 'Delete',
      },
    });

    this.subscription.add(
      sharedDialogRef.afterClosed().subscribe((confirmation) => {
        if (confirmation) {
          const user = this.vaultMembers.find((member) => member.user_id === value);
          this.vaultMembers.splice(this.vaultMembers.indexOf(user), 1);
          const model = {
            id: user.id ? user.id : '',
            user_id: user.user_id ? user.user_id : user.memberUser.id,
          };
          this.subscription.add(
            this.vaultService.deleteVaultMember(model.user_id, model.id).subscribe((data) => {
              if (data) {
                this.selectedUsers = this.selectedUsers.filter((item) => item.id !== user.id);
                this.store$.dispatch(new vaultStoreActions.GetVaultRequestAction(this.userObject?.id, false));
                this.cd.markForCheck();
              }
            })
          );
        } else {
          if (!this.selectedUsers.includes(value)) {
            this.selectedUsers = [...this.selectedUsers, value];
          }
          this.cd.detectChanges();
        }
      })
    );
  }

  getVaultMembers(vault_id) {
    this.subscription.add(
      this.vaultService.getVaultMembers(this.userObject.id, vault_id).subscribe((res) => {
        this.vaultMembers = res;
        this.selectedUsers = this.vaultMembers.map((item) => item.user_id);
        this.cd.detectChanges();
      })
    );
  }

  createRegisterOwner(userId, vault_user_form_id) {
    return new Promise((resolve) => {
      const body = {
        user_id: userId,
        vault_user_form_id: vault_user_form_id,
        owner_type: 'owner',
      };
      if (body) {
        this.subscription.add(
          this.vaultService.postNonVaultPermissionData(body).subscribe((res: any) => {
            if (res) {
              resolve(null);
            }
          })
        );
      }
    });
  }

  deleteRegisterMember(userId, vault_user_form_id, vault_user_share_id, onCancel?: () => void) {
    const sharedDialogRef = this.dialog.open(SharedConfirmationDialogComponent, {
      width: '400px',
      data: {
        title: 'Delete',
        materialIcon: 'delete',
        text: `Are you sure you want to delete this owner?`,
        proceedTitle: 'Delete',
      },
    });
    this.subscription.add(
      sharedDialogRef.afterClosed().subscribe((confirmation) => {
        if (confirmation) {
          if (!vault_user_share_id) {
            this.subscription.add(
              this.vaultService.deleteNonVaultPermissionData(vault_user_form_id, userId).subscribe(() => {
                this.cd.markForCheck();
              })
            );
          } else {
            this.subscription.add(
              this.shareService
                .deleteFormShare({
                  user_id: this.userObject.id,
                  id: vault_user_share_id,
                })
                .subscribe(() => {
                  this.cd.markForCheck();
                })
            );
          }
        } else if (onCancel) {
          // If deletion was cancelled, call the onCancel callback
          onCancel();
        }
      })
    );
  }

  renameInstitutionName() {
    if (!this.formInfo.form_name.trim()) {
      this.toastr.error('Please enter a name for the financial account');
      return;
    }
    const dialogRef = this.dialog.open(RenameInstitutionDialogComponent, {
      width: '386px',
      data: {
        currentInstitutionName: this.formInfo.form_name.trim() ? this.formInfo.form_name.trim() : '',
        title: this.isDiscoveryType6 ? 'Rename Institution' : 'Rename Template',
        subfolderName: this.isDiscoveryType6 ? 'Institution Name' : 'Template Name',
        isDiscoveryType6: this.isDiscoveryType6,
        data: {
          form_name: this.formInfo.form_name.trim(),
          id: this.formInfo.id,
          user_id: this.userObject.id,
        },
      },
    });
    this.subscription.add(
      dialogRef.afterClosed().subscribe((data) => {
        if (data?.confirmation) {
          this.formInfo.form_name = data.institutionName.trim();
          if (this.isDiscoveryType6) {
            this.subscription.add(
              this.discoveryService.updateDiscoveryFinancialAccount(this.formInfo.id, { name: this.formInfo.form_name.trim() }).subscribe(() => {
                this.handleAddNewFinancialAccount.emit({ data: this.formInfo, index: this.index, isRename: true });
                this.cd.detectChanges();
              })
            );
          } else {
            this.formInfo.form_name = data.name;
            this.updateRow();
            this.cd.detectChanges();
          }
        }
      })
    );
  }

  moveFormToVault(vault_id, user_id) {
    let data = {
      vault_id: vault_id,
      id: [this.formInfo.id],
      vault_user_id: user_id ? user_id : this.userObject.id,
    };
    this.subscription.add(
      this.documentService.updateFormGroupId(data).subscribe(() => {
        this.toastr.success('File moved successfully');
      })
    );
  }

  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }
  selectedForm = null;
  toggleDisabled(blur = false) {
    const isNewForm = !this.formInfo?.fid && !!this.formInfo.formId;
    if (this.formInfo.fid || (isNewForm && !blur)) {
      this.selectedForm = { ...structuredClone(this.formInfo) };
      this.formInfo.fid = null;
      this.nameInput?.nativeElement?.focus();
      setTimeout(() => {
        this.nameInput?.nativeElement?.select();
      }, 10);
    }
    if (blur) {
      this.formInfo.fid = this.selectedForm.fid;
      this.nameInput?.nativeElement?.blur();
      setTimeout(() => {
        this.nameInput.nativeElement.select();
      }, 10);
    }
    this.cd.detectChanges();
  }
  handleInputChange(ev: any) {
    if (!this.formInfo.form_name || this.formInfo.form_name === '') {
      this.formInfo.form_name = this.selectedForm.form_name;
    } else if (this.formInfo?.form_name && this.formInfo?.id) {
      if (this.isDiscoveryType6) {
        this.subscription.add(
          this.discoveryService.updateDiscoveryFinancialAccount(this.formInfo.id, { name: this.formInfo.form_name.trim() }).subscribe(() => {
            this.handleAddNewFinancialAccount.emit({ data: this.formInfo, index: this.index, isRename: true });
            this.cd.detectChanges();
          })
        );
      } else {
        this.subscription.add(
          this.documentService
            .saveFormNameInDb({
              form_name: this.formInfo.form_name,
              id: this.formInfo.id,
              form_name_updated_by_user: true,
            })
            .subscribe(() => {
              this.updateRow();
              this.cd.detectChanges();
            })
        );
      }
    }
  }
}
